import joi from "joi";

import {dateSchemaRequired, serviceUidFieldSchema} from "./common";

export const slaOrderSchema = joi.object({
  serviceUid: serviceUidFieldSchema,
  omSla:      joi.string().min(1), // TODO explicit format (?)
  wishDate:   dateSchemaRequired,
});
